import { Factory } from "@/data/dao/Factory";
import { LocationDao } from "@/data/dao/service/LocationDao";
import { LocationState } from "@/data/model/Enums";
import type { ILocation } from "@/data/model/Location";

import { BaseModal } from "@/shared/elements/BaseModal";

import { i18n } from "@/portal/Trans";

export class LocationSuspendModal extends BaseModal {
    private location: ILocation;
    public onStateChanged?: { (newState: LocationState) };

    constructor(loc: ILocation) {
        super("", "modal-md", true);

        this.location = loc;
        this.$element.addClass("locationsuspend");
        if (loc.state === LocationState.Active) this.setActive();
        else if (loc.state === LocationState.Suspended) this.setSuspended();
    }

    private setSuspended() {
        this.setTitle(i18n("modal.locationSuspend.unsuspendTitle"));

        this.$body.append("<p>" + i18n("modal.locationSuspend.unsuspendText") + "</p>");

        const btn = $(
            '<button type="button" class="btn btn-success">' + i18n("modal.locationSuspend.unsuspendBtn") + "</button>"
        )
            .appendTo(this.$footer!)
            .click((e) => {
                e.preventDefault();

                btn.addClass("kt-spinner kt-spinner--sm kt-spinner--light").prop("disabled", true);
                Factory.getInstance<LocationDao>(LocationDao)
                    .reactivate(this.location.id)
                    .then(() => {
                        if (this.onStateChanged !== undefined) this.onStateChanged(LocationState.Active);

                        this.close();
                    });
            });
    }

    private setActive() {
        this.setTitle(i18n("modal.locationSuspend.title"));

        this.$body.append("<p>" + i18n("modal.locationSuspend.suspendText") + "</p>");

        const btn = $(
            '<button type="button" class="btn btn-danger">' + i18n("modal.locationSuspend.suspendBtn") + "</button>"
        )
            .appendTo(this.$footer!)
            .click((e) => {
                e.preventDefault();

                btn.addClass("kt-spinner kt-spinner--sm kt-spinner--light").prop("disabled", true);
                Factory.getInstance<LocationDao>(LocationDao)
                    .suspend(this.location.id)
                    .then(() => {
                        if (this.onStateChanged !== undefined) this.onStateChanged(LocationState.Suspended);

                        this.close();
                    });
            });
    }
}
